// extracted by mini-css-extract-plugin
export default {"container":"Overall_container__Q3edv","wrapper":"Overall_wrapper__QNJm-","info":"Overall_info__Isjlb"};